import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GemsVeinTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GEMS_VEIN;
}

export default GemsVeinTerrainTileEntity;
